import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";

export const orderApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createOrder: builder.mutation({
			query: (body) => ({
				url: "/api/fds-order",
				method: "POST",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			invalidatesTags: ["Badges"],
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				return response;

			},
		}),
	}),
});

export const { useCreateOrderMutation } = orderApiSlice;
